<div class="card row align-center justify-center">
  <span class="card-empty">{{ text }}</span>
</div>
